// extracted by mini-css-extract-plugin
module.exports = {"modalbody":"CustomModal_modalbody__2zc5G","close-btn":"CustomModal_close-btn__2H-kw"};